var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    width: 14.033,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.017.25a6.761 6.761 0 0 1 4.962 2.05 6.742 6.742 0 0 1 2.054 4.95 6.742 6.742 0 0 1 -2.054 4.95 6.761 6.761 0 0 1 -4.962 2.05 6.761 6.761 0 0 1 -4.963-2.05 6.744 6.744 0 0 1 -2.054-4.95 6.74 6.74 0 0 1 2.054-4.95 6.762 6.762 0 0 1 4.963-2.05zm-5.6 7a5.447 5.447 0 0 0 1.183 3.45l7.855-7.887a5.447 5.447 0 0 0 -3.455-1.183 5.379 5.379 0 0 0 -3.944 1.644 5.416 5.416 0 0 0 -1.643 3.976zm5.583 5.62a5.416 5.416 0 0 0 3.976-1.643 5.419 5.419 0 0 0 1.644-3.977 5.447 5.447 0 0 0 -1.183-3.45l-7.855 7.887a5.4 5.4 0 0 0 3.418 1.183z",
    fill: "#3c2f87",
    transform: "translate(0 -.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.5f48c38006d4899085ed6b69b1b8ca3a.svg";
export { ForwardRef as ReactComponent };